export const translations = {
  en: {
    // Navigation
    navBikes: 'Bikes & Scooters',
    navBooking: 'Booking',
    navLocations: 'Locations',
    navContact: 'Contact',
    
    // Hero Section
    heroTitle: 'Motorcycle & Scooter Rental in Thailand',
    heroSubtitle: 'Explore Thailand with ease! No passport deposit • 24/7 delivery • English support',
    heroButton1: 'Browse Vehicles',
    heroButton2: 'Book Now',
    
    // Catalog
    catalogTitle: 'Our Vehicle Fleet',
    filterAll: 'All',
    filterScooters: 'Scooters',
    filterMotorcycles: 'Motorcycles',
    popularBadge: 'Popular',
    pricePerDay: '/day',
    bookButton: 'Book Now',
    
    // Sorting
    sortBy: 'Sort by',
    sortPriceLow: 'Price: Low to High',
    sortPriceHigh: 'Price: High to Low',
    sortName: 'Name A-Z',
    
    // Date Picker
    selectDates: 'Select Rental Dates *',
    datePlaceholder: 'Select start and end date',
    
    // Booking Form
    bookingTitle: 'Booking Form',
    formName: 'Your Name *',
    formEmail: 'Email *',
    formPhone: 'Phone *',
    formBike: 'Select Vehicle',
    formDates: 'Rental Dates *',
    formLocation: 'Pickup Location *',
    formNotes: 'Additional Requests',
    formSubmit: 'Continue to Checkout',
    formNotice1: '⚠️ Requirements: International license category A, passport, deposit.',
    formNotice2: '📞 After submitting, we will contact you to confirm your booking.',
    
    // Price Preview
    priceSummary: 'Price Summary',
    selected: 'Selected',
    dailyRate: 'Daily Rate',
    days: 'Days',
    subtotal: 'Subtotal',
    
    // Locations
    locationsTitle: 'Our Locations in Thailand',
    locationService: '24/7 delivery • English speaking staff',
    
    // Contact
    contactTitle: 'Contact Us',
    contactPhone: 'Phone',
    contactEmail: 'Email',
    contactWhatsApp: 'WhatsApp / Telegram',
    contactHours: 'Working Hours',
    contact24h: '24/7, 7 days a week',
    
    // Footer
    footerTagline: 'Motorcycle and scooter rental across Thailand',
    footerAbout: 'About Us',
    footerDescription: 'Professional motorcycle and scooter rental service throughout Thailand with 24/7 support.',
    footerQuickLinks: 'Quick Links',
    footerContactUs: 'Contact Us',
    footerAddress: 'Address: Soi Petchngam Tambon Talat Nuea, Amphoe Mueang Phuket, Chang Wat Phuket 83000, Thailand',
    footerTerms: 'Terms & Conditions',
    footerPrivacy: 'Privacy Policy',
    footerCancellation: 'Cancellation Policy',
    footerLicense: 'Company License: 0105556003095',
    footerVat: 'VAT ID: TH0123456789013',
    footerRights: '© 2026 ThaiBike Rent. All rights reserved.',
    footerSafety: 'International license required. Ride safely!',
    footerFollow: 'Follow us:',
    footerAllRights: 'All rights reserved.',
    footerRequiredDocs: 'Required documents: International license, passport, security deposit.',
    footerBusinessHours: 'Business Hours: 24/7',
    footerVerified: 'Verified by Thai Ministry of Tourism',
    footerInsurance: 'Insurance included in all rentals',
    
    // Invoice Page
    invoiceTitle: 'Booking Invoice',
    orderNumber: 'Order #',
    rentalDetails: 'Rental Details',
    customer: 'Customer',
    email: 'Email',
    vehicle: 'Vehicle',
    rentalPeriod: 'Rental Period',
    pickupLocation: 'Pickup Location',
    priceBreakdown: 'Price Breakdown',
    deliveryInformation: 'Delivery Information',
    deliveryInfoText: 'Now you need to pay for bike delivery to your address. Enter your delivery address below.',
    deliveryCostFixed: 'Delivery cost is fixed at 30฿ anywhere in Thailand.',
    deliveryTime: 'Estimated delivery time: 60-90 minutes after confirmation.',
    streetAddress: 'Street Address *',
    city: 'City *',
    postalCode: 'Postal Code *',
    province: 'Province *',
    district: 'District',
    country: 'Country *',
    deliveryNotes: 'Delivery Notes',
    enterValidAddress: 'Please fill in all required address fields',
    deliveryConfirmed: 'Delivery address saved!',
    taxIncluded: 'All taxes included. No hidden fees.',
    securePayment: '256-bit SSL secure payment',
    backToBooking: '← Back to Booking',
    proceedToPayment: 'Proceed to Secure Payment',
    fillAllFields: 'Please fill in all required fields',
    calculateDeliveryFirst: 'Please fill in delivery address first',
    addressSaved: '✓ Address saved',
    
    // Error Messages
    selectBikeDates: 'Please select a bike and dates',
    enterStreetCity: 'Please enter street and city',
    deliveryFailed: 'Failed to save address. Please try again.',
    loading: 'Loading...',
    
    // Page Titles
    pageTerms: 'Terms & Conditions',
    pagePrivacy: 'Privacy Policy',
    pageCancellation: 'Cancellation Policy',
    
    // Terms Page Content
    termsTitle: 'Terms and Conditions of Rental',
    termsEffective: 'Effective Date: January 1, 2026',
    termsIntro: 'Welcome to ThaiBike Rent. These Terms and Conditions govern your rental of motorcycles and scooters from our service.',
    termsSection1: '1. Rental Agreement',
    termsContent1: 'By renting a vehicle from ThaiBike Rent, you agree to these terms. You must be at least 18 years old with a valid international driver\'s license.',
    termsSection2: '2. Rental Period',
    termsContent2: 'The rental period begins at the time specified in your booking and ends when the vehicle is returned. Late returns incur additional charges.',
    termsSection3: '3. Vehicle Condition',
    termsContent3: 'You will receive the vehicle in good working condition. You are responsible for any damage during your rental period.',
    termsSection4: '4. Insurance',
    termsContent4: 'Basic insurance is included. Additional coverage is available for purchase.',
    termsSection5: '5. Payment',
    termsContent5: 'Full payment is required before vehicle pickup. We accept credit cards and cash.',
    termsContact: 'For questions about these terms, contact us at info@thaibikerent.com.',
    
    // Privacy Page Content
    privacyTitle: 'Privacy Policy',
    privacyEffective: 'Effective Date: January 1, 2026',
    privacyIntro: 'ThaiBike Rent respects your privacy and is committed to protecting your personal data.',
    privacySection1: '1. Information We Collect',
    privacyContent1: 'We collect personal information such as name, email, phone number, driver\'s license details, and payment information.',
    privacySection2: '2. How We Use Your Information',
    privacyContent2: 'Your information is used to process rentals, provide customer support, and improve our services.',
    privacySection3: '3. Data Security',
    privacyContent3: 'We implement security measures to protect your personal data from unauthorized access.',
    privacySection4: '4. Data Sharing',
    privacyContent4: 'We do not sell your data. We may share information with law enforcement if required by law.',
    privacySection5: '5. Your Rights',
    privacyContent5: 'You have the right to access, correct, or delete your personal information.',
    
    // Cancellation Page Content
    cancellationTitle: 'Cancellation Policy',
    cancellationEffective: 'Effective Date: January 1, 2026',
    cancellationIntro: 'Our cancellation policy is designed to be fair to both customers and our business.',
    cancellationSection1: '1. Free Cancellation',
    cancellationContent1: 'Cancel up to 48 hours before pickup for a full refund.',
    cancellationSection2: '2. Late Cancellation',
    cancellationContent2: 'Cancellations within 24-48 hours receive a 50% refund.',
    cancellationSection3: '3. No Show',
    cancellationContent3: 'No refund for cancellations within 24 hours or no-shows.',
    cancellationSection4: '4. Early Return',
    cancellationContent4: 'Early returns do not qualify for partial refunds.',
    cancellationSection5: '5. Weather Cancellations',
    cancellationContent5: 'In case of severe weather, we offer rescheduling or full refund.',

        // Invoice Page - Новые переводы
    customerInfo: 'Customer Information',
    rentalDetails: 'Rental Details',
    deliveryInformation: 'Delivery Information',
    paymentSummary: 'Payment Summary',
    completeToProceed: 'Complete to proceed with payment',
    deliveryWithin60: 'Delivery within 60 minutes',
    deliveryFeeNote: 'Standard delivery fee: 30฿ • Available 8:00 AM - 10:00 PM',
    deliveryAddress: 'Delivery Address',
    requiredFields: '* Required fields',
    saveAddress: 'Save Delivery Address',
    saving: 'Saving...',
    addressSavedSuccess: 'Address Saved Successfully!',
    deliveryConfirmation: 'Delivery will be made to this address within 60 minutes.',
    fillRequiredFields: 'Please fill all required fields marked with *',
    cardPaymentOnly: 'Card payment only',
    deliveryFee: 'Delivery Fee:',
    rentalAmount: 'Rental Amount:',
    paidSeparately: 'Paid Separately',
    totalToPay: 'Total to Pay:',
    creditDebitCard: 'Credit / Debit Card',
    cardTypes: 'Visa, MasterCard, American Express',
    payNow: 'Pay Now',
    secureNote: 'Your payment is secure and encrypted. We don\'t store card details.',
    needHelp: 'Need Help?',
    support24_7: 'Our support team is available 24/7 to assist you.',
    importantInfo: 'Important Information',
    freeDeliveryOver7: 'Free delivery for rentals over 7 days',
    driverContact: 'Driver will contact you 15 minutes before arrival',
    haveIDReady: 'Have your ID and driving license ready',
    support24_7_2: '24/7 customer support available',
    twoStepPayment: 'First, pay for delivery (30฿). After verification and contract signing, you\'ll pay for the bike rental separately.',
    orderIdLabel: 'Order ID:',
    dateLabel: 'Date:',
    paymentProcessTitle: 'Payment Process',
    paymentStep1: '1. Pay delivery fee (30฿) - Now',
    paymentStep2: '2. Document verification & contract signing',
    paymentStep3: '3. Pay bike rental fee - After contract',
    paymentProcessNote: 'This ensures your booking is confirmed and bike is reserved for you.',
    deliveryNotesOptional: 'Delivery Notes (Optional)',
    orderStatus: 'Order Status',
    paymentPending: 'Payment Pending',
    paymentComplete: 'Complete Payment',
    
    // Новые для шагов оплаты
    stepDelivery: 'Step 1: Delivery Fee',
    stepVerification: 'Step 2: Verification',
    stepRental: 'Step 3: Rental Payment',
    currentStep: 'Current Step:',
    nextStep: 'Next Step:',
    deliveryFeePaid: 'Delivery fee paid',
    documentsVerified: 'Documents verified',
    contractSigned: 'Contract signed',
    bikePaymentReady: 'Bike payment ready',

    // Currency
    currencyNotice: 'Prices available in THB, USD, EUR. Select your preferred currency above.',
    displayPricesIn: 'Display prices in:',
    
    // Bike Descriptions
    bikeDesc1: 'Economical and reliable scooter for city riding',
    bikeDesc2: 'Compact and maneuverable scooter',
    bikeDesc3: 'Stylish and economical city scooter',
    bikeDesc4: 'Powerful and comfortable scooter for long trips',
    bikeDesc5: 'Modern scooter with ABS and large storage',
    bikeDesc6: 'Sporty scooter with vibrant design',
    bikeDesc7: 'Adventure scooter for off-road riding',
    bikeDesc8: 'Classic Italian style scooter',
    bikeDesc9: 'Maxi-scooter for comfortable touring',
    bikeDesc10: 'Premium touring scooter',
    bikeDesc11: 'Modern neo-classic motorcycle',
    bikeDesc12: 'Sporty motorcycle for city riding',
    bikeDesc13: 'Adventure touring motorcycle',
    bikeDesc14: 'Sport bike for track and city',
    bikeDesc15: 'Off-road enduro motorcycle',
    bikeDesc16: 'Premium city motorcycle',
    bikeDesc17: 'Adventure motorcycle for long journeys',
    bikeDesc18: 'Italian style and power',
    bikeDesc19: 'American classic cruiser',
    bikeDesc20: 'Premium adventure touring motorcycle',
    
    // Currency Info
    currencyInfo1: 'All prices are converted at checkout',
    currencyInfo2: 'No hidden fees or conversion charges',
    currencyInfo3: 'Payment processed in selected currency',
    currencyInfo4: 'Exchange rates updated daily',
    currencyInfoTitle: 'Currency Information',
    
    // Location Delivery Times
    deliveryPhuket: 'Delivery: 60-90 minutes',
    deliveryBangkok: 'Delivery: 45-60 minutes',
    deliveryChiangmai: 'Delivery: 30-45 minutes',
    deliveryKrabi: 'Delivery: 60-90 minutes',
    deliveryPattaya: 'Delivery: 30-45 minutes',
    deliverySamui: 'Delivery: 60-90 minutes',
  },
  
  de: {
    // Navigation
    navBikes: 'Motorräder & Roller',
    navBooking: 'Buchung',
    navLocations: 'Standorte',
    navContact: 'Kontakt',
    
    // Hero Section
    heroTitle: 'Motorrad- & Rollerverleih in Thailand',
    heroSubtitle: 'Entdecken Sie Thailand mühelos! Kein Passpfand • 24/7 Lieferung • Deutschsprachiger Support',
    heroButton1: 'Fahrzeuge ansehen',
    heroButton2: 'Jetzt buchen',
    
    // Catalog
    catalogTitle: 'Unsere Fahrzeugflotte',
    filterAll: 'Alle',
    filterScooters: 'Roller',
    filterMotorcycles: 'Motorräder',
    popularBadge: 'Beliebt',
    pricePerDay: '/Tag',
    bookButton: 'Jetzt buchen',
    
    // Sorting
    sortBy: 'Sortieren nach',
    sortPriceLow: 'Preis: Niedrig zu Hoch',
    sortPriceHigh: 'Preis: Hoch zu Niedrig',
    sortName: 'Name A-Z',
    
    // Date Picker
    selectDates: 'Mietzeitraum auswählen *',
    datePlaceholder: 'Start- und Enddatum auswählen',
    
    // Booking Form
    bookingTitle: 'Buchungsformular',
    formName: 'Ihr Name *',
    formEmail: 'E-Mail *',
    formPhone: 'Telefon *',
    formBike: 'Fahrzeug wählen',
    formDates: 'Mietzeitraum *',
    formLocation: 'Abholort *',
    formNotes: 'Zusätzliche Wünsche',
    formSubmit: 'Zur Kasse gehen',
    formNotice1: '⚠️ Voraussetzungen: Internationaler Führerschein Klasse A, Reisepass, Kaution.',
    formNotice2: '📞 Nach Absenden kontaktieren wir Sie zur Buchungsbestätigung.',
    
    // Price Preview
    priceSummary: 'Preiszusammenfassung',
    selected: 'Ausgewählt',
    dailyRate: 'Tagespreis',
    days: 'Tage',
    subtotal: 'Zwischensumme',
    
    // Locations
    locationsTitle: 'Unsere Standorte in Thailand',
    locationService: '24/7 Lieferung • Deutschsprachiges Personal',
    
    // Contact
    contactTitle: 'Kontaktieren Sie uns',
    contactPhone: 'Telefon',
    contactEmail: 'E-Mail',
    contactWhatsApp: 'WhatsApp / Telegram',
    contactHours: 'Öffnungszeiten',
    contact24h: '24/7, 7 Tage die Woche',
    
    // Footer
    footerTagline: 'Motorrad- und Rollerverleih in ganz Thailand',
    footerAbout: 'Über uns',
    footerDescription: 'Professioneller Motorrad- und Rollerverleih in ganz Thailand mit 24/7 Support.',
    footerQuickLinks: 'Schnellzugriff',
    footerContactUs: 'Kontakt',
    footerAddress: 'Adresse: Soi Petchngam Tambon Talat Nuea, Amphoe Mueang Phuket, Chang Wat Phuket 83000, Thailand',
    footerTerms: 'Allgemeine Geschäftsbedingungen',
    footerPrivacy: 'Datenschutzerklärung',
    footerCancellation: 'Stornierungsbedingungen',
    footerLicense: 'Firmenlizenz: 0105556003095',
    footerVat: 'Umsatzsteuer-ID: TH0123456789013',
    footerRights: '© 2026 ThaiBike Rent. Alle Rechte vorbehalten.',
    footerSafety: 'Internationaler Führerschein erforderlich. Fahren Sie sicher!',
    footerFollow: 'Folgen Sie uns:',
    footerAllRights: 'Alle Rechte vorbehalten.',
    footerRequiredDocs: 'Erforderliche Dokumente: Internationaler Führerschein, Reisepass, Sicherheitsleistung.',
    footerBusinessHours: 'Geschäftszeiten: 24/7',
    footerVerified: 'Geprüft vom thailändischen Tourismusministerium',
    footerInsurance: 'Versicherung in allen Vermietungen inklusive',
    
    // Invoice Page
    invoiceTitle: 'Buchungsrechnung',
    orderNumber: 'Bestellung #',
    rentalDetails: 'Mietdetails',
    customer: 'Kunde',
    email: 'E-Mail',
    vehicle: 'Fahrzeug',
    rentalPeriod: 'Mietzeitraum',
    pickupLocation: 'Abholort',
    priceBreakdown: 'Preisaufschlüsselung',
    deliveryInformation: 'Lieferinformationen',
    deliveryInfoText: 'Jetzt müssen Sie die Fahrzeuglieferung an Ihre Adresse bezahlen. Geben Sie unten Ihre Lieferadresse ein.',
    deliveryCostFixed: 'Lieferkosten betragen pauschal 30฿ in ganz Thailand.',
    deliveryTime: 'Geschätzte Lieferzeit: 60-90 Minuten nach Bestätigung.',
    streetAddress: 'Straße und Hausnummer *',
    city: 'Stadt *',
    postalCode: 'Postleitzahl *',
    province: 'Provinz *',
    district: 'Bezirk',
    country: 'Land *',
    deliveryNotes: 'Lieferhinweise',
    enterValidAddress: 'Bitte füllen Sie alle erforderlichen Adressfelder aus',
    deliveryConfirmed: 'Lieferadresse gespeichert!',
    taxIncluded: 'Alle Steuern inklusive. Keine versteckten Gebühren.',
    securePayment: '256-Bit SSL sichere Zahlung',
    backToBooking: '← Zurück zur Buchung',
    proceedToPayment: 'Zur sicheren Zahlung',
    fillAllFields: 'Bitte füllen Sie alle erforderlichen Felder aus',
    calculateDeliveryFirst: 'Bitte zuerst Lieferadresse ausfüllen',
    addressSaved: '✓ Adresse gespeichert',
    
    // Error Messages
    selectBikeDates: 'Bitte wählen Sie ein Fahrzeug und Datum aus',
    enterStreetCity: 'Bitte geben Sie Straße und Stadt ein',
    deliveryFailed: 'Adresse konnte nicht gespeichert werden. Bitte versuchen Sie es erneut.',
    loading: 'Wird geladen...',
    
    // Page Titles
    pageTerms: 'Allgemeine Geschäftsbedingungen',
    pagePrivacy: 'Datenschutzerklärung',
    pageCancellation: 'Stornierungsbedingungen',
    
    // Terms Page Content
    termsTitle: 'Allgemeine Geschäftsbedingungen für die Vermietung',
    termsEffective: 'Gültig ab: 1. Januar 2026',
    termsIntro: 'Willkommen bei ThaiBike Rent. Diese Allgemeinen Geschäftsbedingungen regeln Ihre Vermietung von Motorrädern und Rollern von unserem Service.',
    termsSection1: '1. Mietvertrag',
    termsContent1: 'Durch die Anmietung eines Fahrzeugs von ThaiBike Rent stimmen Sie diesen Bedingungen zu. Sie müssen mindestens 18 Jahre alt sein und einen gültigen internationalen Führerschein besitzen.',
    termsSection2: '2. Mietzeitraum',
    termsContent2: 'Der Mietzeitraum beginnt zum in Ihrer Buchung angegebenen Zeitpunkt und endet, wenn das Fahrzeug zurückgegeben wird. Verspätete Rückgaben verursachen zusätzliche Gebühren.',
    termsSection3: '3. Fahrzeugzustand',
    termsContent3: 'Sie erhalten das Fahrzeug in gutem Betriebszustand. Sie sind für Schäden während Ihres Mietzeitraums verantwortlich.',
    termsSection4: '4. Versicherung',
    termsContent4: 'Grundversicherung ist inbegriffen. Zusätzlicher Schutz kann erworben werden.',
    termsSection5: '5. Zahlung',
    termsContent5: 'Volle Zahlung ist vor Abholung des Fahrzeugs erforderlich. Wir akzeptieren Kreditkarten und Bargeld.',
    termsContact: 'Bei Fragen zu diesen Bedingungen kontaktieren Sie uns unter info@thaibikerent.com.',
    
    // Privacy Page Content
    privacyTitle: 'Datenschutzerklärung',
    privacyEffective: 'Gültig ab: 1. Januar 2026',
    privacyIntro: 'ThaiBike Rent respektiert Ihre Privatsphäre und ist dem Schutz Ihrer persönlichen Daten verpflichtet.',
    privacySection1: '1. Informationen, die wir sammeln',
    privacyContent1: 'Wir sammeln persönliche Informationen wie Name, E-Mail, Telefonnummer, Führerscheindetails und Zahlungsinformationen.',
    privacySection2: '2. Wie wir Ihre Informationen verwenden',
    privacyContent2: 'Ihre Informationen werden verwendet, um Vermietungen zu bearbeiten, Kundensupport zu bieten und unsere Dienstleistungen zu verbessern.',
    privacySection3: '3. Datensicherheit',
    privacyContent3: 'Wir implementieren Sicherheitsmaßnahmen, um Ihre persönlichen Daten vor unbefugtem Zugriff zu schützen.',
    privacySection4: '4. Datenweitergabe',
    privacyContent4: 'Wir verkaufen Ihre Daten nicht. Wir können Informationen mit Strafverfolgungsbehörden teilen, wenn dies gesetzlich vorgeschrieben ist.',
    privacySection5: '5. Ihre Rechte',
    privacyContent5: 'Sie haben das Recht, auf Ihre persönlichen Informationen zuzugreifen, sie zu korrigieren oder zu löschen.',
    
    // Cancellation Page Content
    cancellationTitle: 'Stornierungsbedingungen',
    cancellationEffective: 'Gültig ab: 1. Januar 2026',
    cancellationIntro: 'Unsere Stornierungsbedingungen sind darauf ausgelegt, sowohl für Kunden als auch für unser Unternehmen fair zu sein.',
    cancellationSection1: '1. Kostenlose Stornierung',
    cancellationContent1: 'Stornieren Sie bis zu 48 Stunden vor der Abholung für eine vollständige Rückerstattung.',
    cancellationSection2: '2. Späte Stornierung',
    cancellationContent2: 'Stornierungen innerhalb von 24-48 Stunden erhalten eine 50%ige Rückerstattung.',
    cancellationSection3: '3. Nichterscheinen',
    cancellationContent3: 'Keine Rückerstattung für Stornierungen innerhalb von 24 Stunden oder Nichterscheinen.',
    cancellationSection4: '4. Vorzeitige Rückgabe',
    cancellationContent4: 'Vorzeitige Rückgaben qualifizieren sich nicht für Teilrückerstattungen.',
    cancellationSection5: '5. Wetterbedingte Stornierungen',
    cancellationContent5: 'Bei extremen Wetterbedingungen bieten wir eine Terminänderung oder volle Rückerstattung.',

     // Invoice Page - Новые переводы
    customerInfo: 'Kundeninformationen',
    rentalDetails: 'Mietdetails',
    deliveryInformation: 'Lieferinformationen',
    paymentSummary: 'Zahlungsübersicht',
    completeToProceed: 'Ausfüllen, um mit der Zahlung fortzufahren',
    deliveryWithin60: 'Lieferung innerhalb von 60 Minuten',
    deliveryFeeNote: 'Standardliefergebühr: 30฿ • Verfügbar 8:00-22:00 Uhr',
    deliveryAddress: 'Lieferadresse',
    requiredFields: '* Pflichtfelder',
    saveAddress: 'Lieferadresse speichern',
    saving: 'Wird gespeichert...',
    addressSavedSuccess: 'Adresse erfolgreich gespeichert!',
    deliveryConfirmation: 'Die Lieferung erfolgt innerhalb von 60 Minuten an diese Adresse.',
    fillRequiredFields: 'Bitte füllen Sie alle mit * gekennzeichneten Pflichtfelder aus',
    cardPaymentOnly: 'Nur Kartenzahlung',
    deliveryFee: 'Liefergebühr:',
    rentalAmount: 'Mietbetrag:',
    paidSeparately: 'Separat bezahlt',
    totalToPay: 'Zu zahlender Betrag:',
    creditDebitCard: 'Kredit-/Debitkarte',
    cardTypes: 'Visa, MasterCard, American Express',
    payNow: 'Jetzt bezahlen',
    secureNote: 'Ihre Zahlung ist sicher und verschlüsselt. Wir speichern keine Kartendaten.',
    needHelp: 'Hilfe benötigt?',
    support24_7: 'Unser Support-Team ist 24/7 für Sie da.',
    importantInfo: 'Wichtige Informationen',
    freeDeliveryOver7: 'Kostenlose Lieferung bei Mieten über 7 Tage',
    driverContact: 'Fahrer kontaktiert Sie 15 Minuten vor Ankunft',
    haveIDReady: 'Halten Sie Ihren Ausweis und Führerschein bereit',
    support24_7_2: '24/7 Kundensupport verfügbar',
    twoStepPayment: 'Zuerst zahlen Sie die Liefergebühr (30฿). Nach der Überprüfung und Vertragsunterzeichnung zahlen Sie die Motorradmiete separat.',
    orderIdLabel: 'Bestellnummer:',
    dateLabel: 'Datum:',
    paymentProcessTitle: 'Zahlungsprozess',
    paymentStep1: '1. Liefergebühr bezahlen (30฿) - Jetzt',
    paymentStep2: '2. Dokumentenprüfung & Vertragsunterzeichnung',
    paymentStep3: '3. Motorradmiete bezahlen - Nach Vertrag',
    paymentProcessNote: 'Dies stellt sicher, dass Ihre Buchung bestätigt und das Motorrad für Sie reserviert ist.',
    deliveryNotesOptional: 'Lieferhinweise (Optional)',
    orderStatus: 'Bestellstatus',
    paymentPending: 'Zahlung ausstehend',
    paymentComplete: 'Zahlung abschließen',
    
    // Новые для шагов оплаты
    stepDelivery: 'Schritt 1: Liefergebühr',
    stepVerification: 'Schritt 2: Überprüfung',
    stepRental: 'Schritt 3: Mietzahlung',
    currentStep: 'Aktueller Schritt:',
    nextStep: 'Nächster Schritt:',
    deliveryFeePaid: 'Liefergebühr bezahlt',
    documentsVerified: 'Dokumente geprüft',
    contractSigned: 'Vertrag unterschrieben',
    bikePaymentReady: 'Motorradzahlung bereit',

     currencyNotice: 'Preise in THB, USD, EUR verfügbar. Wählen Sie oben Ihre bevorzugte Währung.',
    displayPricesIn: 'Preise anzeigen in:',
    
    // Bike Descriptions
    bikeDesc1: 'Wirtschaftlicher und zuverlässiger Roller für die Stadt',
    bikeDesc2: 'Kompakter und wendiger Roller',
    bikeDesc3: 'Stilvoller und wirtschaftlicher Stadtscooter',
    bikeDesc4: 'Leistungsstarker und komfortabler Roller für lange Fahrten',
    bikeDesc5: 'Moderner Roller mit ABS und großem Stauraum',
    bikeDesc6: 'Sportlicher Roller mit lebendigem Design',
    bikeDesc7: 'Abenteuer-Roller für Geländefahrten',
    bikeDesc8: 'Klassischer italienischer Stilroller',
    bikeDesc9: 'Maxi-Roller für komfortable Touren',
    bikeDesc10: 'Premium-Touring-Roller',
    bikeDesc11: 'Modernes Neo-Classic Motorrad',
    bikeDesc12: 'Sportliches Motorrad für die Stadt',
    bikeDesc13: 'Abenteuer-Touring-Motorrad',
    bikeDesc14: 'Sportbike für Rennstrecke und Stadt',
    bikeDesc15: 'Offroad-Enduro-Motorrad',
    bikeDesc16: 'Premium-Stadtmotorrad',
    bikeDesc17: 'Abenteuermotorrad für lange Reisen',
    bikeDesc18: 'Italienischer Stil und Leistung',
    bikeDesc19: 'Amerikanischer Classic Cruiser',
    bikeDesc20: 'Premium-Abenteuer-Touring-Motorrad',
    
    // Currency Info
    currencyInfo1: 'Alle Preise werden an der Kasse umgerechnet',
    currencyInfo2: 'Keine versteckten Gebühren oder Umrechnungskosten',
    currencyInfo3: 'Zahlung in der ausgewählten Währung',
    currencyInfo4: 'Wechselkurse täglich aktualisiert',
    currencyInfoTitle: 'Währungsinformationen',
    
    // Location Delivery Times
    deliveryPhuket: 'Lieferung: 60-90 Minuten',
    deliveryBangkok: 'Lieferung: 45-60 Minuten',
    deliveryChiangmai: 'Lieferung: 30-45 Minuten',
    deliveryKrabi: 'Lieferung: 60-90 Minuten',
    deliveryPattaya: 'Lieferung: 30-45 Minuten',
    deliverySamui: 'Lieferung: 60-90 Minuten',
  },
  
  fr: {
    // Navigation
    navBikes: 'Motos & Scooters',
    navBooking: 'Réservation',
    navLocations: 'Emplacements',
    navContact: 'Contact',
    
    // Hero Section
    heroTitle: 'Location de Motos & Scooters en Thaïlande',
    heroSubtitle: 'Explorez la Thaïlande en toute simplicité ! Pas de dépôt de passeport • Livraison 24/7 • Support en français',
    heroButton1: 'Voir les véhicules',
    heroButton2: 'Réserver maintenant',
    
    // Catalog
    catalogTitle: 'Notre flotte de véhicules',
    filterAll: 'Tous',
    filterScooters: 'Scooters',
    filterMotorcycles: 'Motos',
    popularBadge: 'Populaire',
    pricePerDay: '/jour',
    bookButton: 'Réserver',
    
    // Sorting
    sortBy: 'Trier par',
    sortPriceLow: 'Prix: Croissant',
    sortPriceHigh: 'Prix: Décroissant',
    sortName: 'Nom A-Z',
    
    // Date Picker
    selectDates: 'Sélectionner les dates de location *',
    datePlaceholder: 'Sélectionner la date de début et de fin',
    
    // Booking Form
    bookingTitle: 'Formulaire de réservation',
    formName: 'Votre nom *',
    formEmail: 'Email *',
    formPhone: 'Téléphone *',
    formBike: 'Choisir un véhicule',
    formDates: 'Dates de location *',
    formLocation: 'Lieu de prise en charge *',
    formNotes: 'Demandes supplémentaires',
    formSubmit: 'Passer à la caisse',
    formNotice1: '⚠️ Exigences : Permis international catégorie A, passeport, dépôt de garantie.',
    formNotice2: '📞 Après envoi, nous vous contacterons pour confirmer votre réservation.',
    
    // Price Preview
    priceSummary: 'Récapitulatif des prix',
    selected: 'Sélectionné',
    dailyRate: 'Tarif journalier',
    days: 'Jours',
    subtotal: 'Sous-total',
    
    // Locations
    locationsTitle: 'Nos emplacements en Thaïlande',
    locationService: 'Livraison 24/7 • Personnel francophone',
    
    // Contact
    contactTitle: 'Contactez-nous',
    contactPhone: 'Téléphone',
    contactEmail: 'Email',
    contactWhatsApp: 'WhatsApp / Telegram',
    contactHours: 'Heures d\'ouverture',
    contact24h: '24/7, 7 jours sur 7',
    
    // Footer
    footerTagline: 'Location de motos et scooters dans toute la Thaïlande',
    footerAbout: 'À propos',
    footerDescription: 'Service professionnel de location de motos et scooters dans toute la Thaïlande avec support 24/7.',
    footerQuickLinks: 'Liens rapides',
    footerContactUs: 'Contactez-nous',
    footerAddress: 'Adresse : 123 Beach Road, Patong, Phuket 83150, Thaïlande',
    footerTerms: 'Conditions générales',
    footerPrivacy: 'Politique de confidentialité',
    footerCancellation: 'Politique d\'annulation',
    footerLicense: 'Licence d\'entreprise : 0105556003095',
    footerVat: 'Numéro de TVA : TH0123456789013',
    footerRights: '© 2026 ThaiBike Rent. Tous droits réservés.',
    footerSafety: 'Permis international requis. Conduisez prudemment !',
    footerFollow: 'Suivez-nous :',
    footerAllRights: 'Tous droits réservés.',
    footerRequiredDocs: 'Documents requis : Permis international, passeport, caution.',
    footerBusinessHours: 'Heures d\'ouverture : 24/7',
    footerVerified: 'Vérifié par le ministère du tourisme thaïlandais',
    footerInsurance: 'Assurance incluse dans toutes les locations',
    
    // Invoice Page
    invoiceTitle: 'Facture de réservation',
    orderNumber: 'Commande #',
    rentalDetails: 'Détails de location',
    customer: 'Client',
    email: 'Email',
    vehicle: 'Véhicule',
    rentalPeriod: 'Période de location',
    pickupLocation: 'Lieu de prise en charge',
    priceBreakdown: 'Détail des prix',
    deliveryInformation: 'Informations de livraison',
    deliveryInfoText: 'Maintenant, vous devez payer la livraison du véhicule à votre adresse. Entrez votre adresse de livraison ci-dessous.',
    deliveryCostFixed: 'Les frais de livraison sont fixes à 30฿ partout en Thaïlande.',
    deliveryTime: 'Délai de livraison estimé : 60-90 minutes après confirmation.',
    streetAddress: 'Adresse *',
    city: 'Ville *',
    postalCode: 'Code postal *',
    province: 'Province *',
    district: 'District',
    country: 'Pays *',
    deliveryNotes: 'Notes de livraison',
    enterValidAddress: 'Veuillez remplir tous les champs d\'adresse requis',
    deliveryConfirmed: 'Adresse de livraison enregistrée !',
    taxIncluded: 'Toutes taxes incluses. Pas de frais cachés.',
    securePayment: 'Paiement sécurisé SSL 256 bits',
    backToBooking: '← Retour à la réservation',
    proceedToPayment: 'Procéder au paiement sécurisé',
    fillAllFields: 'Veuillez remplir tous les champs requis',
    calculateDeliveryFirst: 'Veuillez d\'abord remplir l\'adresse de livraison',
    addressSaved: '✓ Adresse enregistrée',
    
    // Error Messages
    selectBikeDates: 'Veuillez sélectionner un véhicule et des dates',
    enterStreetCity: 'Veuillez saisir l\'adresse et la ville',
    deliveryFailed: 'Échec de l\'enregistrement de l\'adresse. Veuillez réessayer.',
    loading: 'Chargement...',
    
    // Page Titles
    pageTerms: 'Conditions générales',
    pagePrivacy: 'Politique de confidentialité',
    pageCancellation: 'Politique d\'annulation',
    
    // Terms Page Content
    termsTitle: 'Conditions générales de location',
    termsEffective: 'Date d\'effet : 1er janvier 2026',
    termsIntro: 'Bienvenue chez ThaiBike Rent. Ces Conditions générales régissent votre location de motos et scooters auprès de notre service.',
    termsSection1: '1. Contrat de location',
    termsContent1: 'En louant un véhicule chez ThaiBike Rent, vous acceptez ces conditions. Vous devez avoir au moins 18 ans et posséder un permis de conduire international valide.',
    termsSection2: '2. Période de location',
    termsContent2: 'La période de location commence à l\'heure spécifiée dans votre réservation et se termine lorsque le véhicule est retourné. Les retards entraînent des frais supplémentaires.',
    termsSection3: '3. État du véhicule',
    termsContent3: 'Vous recevrez le véhicule en bon état de fonctionnement. Vous êtes responsable de tout dommage pendant votre période de location.',
    termsSection4: '4. Assurance',
    termsContent4: 'L\'assurance de base est incluse. Une couverture supplémentaire est disponible à l\'achat.',
    termsSection5: '5. Paiement',
    termsContent5: 'Le paiement intégral est requis avant la prise en charge du véhicule. Nous acceptons les cartes de crédit et l\'argent liquide.',
    termsContact: 'Pour toute question concernant ces conditions, contactez-nous à info@thaibikerent.com.',
    
    // Privacy Page Content
    privacyTitle: 'Politique de confidentialité',
    privacyEffective: 'Date d\'effet : 1er janvier 2026',
    privacyIntro: 'ThaiBike Rent respecte votre vie privée et s\'engage à protéger vos données personnelles.',
    privacySection1: '1. Informations que nous collectons',
    privacyContent1: 'Nous collectons des informations personnelles telles que le nom, l\'email, le numéro de téléphone, les détails du permis de conduire et les informations de paiement.',
    privacySection2: '2. Comment nous utilisons vos informations',
    privacyContent2: 'Vos informations sont utilisées pour traiter les locations, fournir un support client et améliorer nos services.',
    privacySection3: '3. Sécurité des données',
    privacyContent3: 'Nous mettons en œuvre des mesures de sécurité pour protéger vos données personnelles contre tout accès non autorisé.',
    privacySection4: '4. Partage des données',
    privacyContent4: 'Nous ne vendons pas vos données. Nous pouvons partager des informations avec les forces de l\'ordre si la loi l\'exige.',
    privacySection5: '5. Vos droits',
    privacyContent5: 'Vous avez le droit d\'accéder, de corriger ou de supprimer vos informations personnelles.',
    
    // Cancellation Page Content
    cancellationTitle: 'Politique d\'annulation',
    cancellationEffective: 'Date d\'effet : 1er janvier 2026',
    cancellationIntro: 'Notre politique d\'annulation est conçue pour être équitable à la fois pour les clients et notre entreprise.',
    cancellationSection1: '1. Annulation gratuite',
    cancellationContent1: 'Annulez jusqu\'à 48 heures avant la prise en charge pour un remboursement complet.',
    cancellationSection2: '2. Annulation tardive',
    cancellationContent2: 'Les annulations dans les 24-48 heures reçoivent un remboursement de 50%.',
    cancellationSection3: '3. Non-présentation',
    cancellationContent3: 'Aucun remboursement pour les annulations dans les 24 heures ou les non-présentations.',
    cancellationSection4: '4. Retour anticipé',
    cancellationContent4: 'Les retours anticipés ne donnent pas droit à un remboursement partiel.',
    cancellationSection5: '5. Annulations météorologiques',
    cancellationContent5: 'En cas de conditions météorologiques sévères, nous proposons un report ou un remboursement complet.',

     // Invoice Page - Новые переводы
    customerInfo: 'Informations client',
    rentalDetails: 'Détails de location',
    deliveryInformation: 'Informations de livraison',
    paymentSummary: 'Récapitulatif de paiement',
    completeToProceed: 'Remplir pour procéder au paiement',
    deliveryWithin60: 'Livraison en 60 minutes',
    deliveryFeeNote: 'Frais de livraison standard : 30฿ • Disponible 8h-22h',
    deliveryAddress: 'Adresse de livraison',
    requiredFields: '* Champs obligatoires',
    saveAddress: 'Enregistrer l\'adresse de livraison',
    saving: 'Enregistrement...',
    addressSavedSuccess: 'Adresse enregistrée avec succès !',
    deliveryConfirmation: 'La livraison sera effectuée à cette adresse dans les 60 minutes.',
    fillRequiredFields: 'Veuillez remplir tous les champs obligatoires marqués d\'un *',
    cardPaymentOnly: 'Paiement par carte uniquement',
    deliveryFee: 'Frais de livraison :',
    rentalAmount: 'Montant de la location :',
    paidSeparately: 'Payé séparément',
    totalToPay: 'Total à payer :',
    creditDebitCard: 'Carte de crédit/débit',
    cardTypes: 'Visa, MasterCard, American Express',
    payNow: 'Payer maintenant',
    secureNote: 'Votre paiement est sécurisé et chiffré. Nous ne stockons pas les données de carte.',
    needHelp: 'Besoin d\'aide ?',
    support24_7: 'Notre équipe d\'assistance est disponible 24h/24 et 7j/7.',
    importantInfo: 'Informations importantes',
    freeDeliveryOver7: 'Livraison gratuite pour les locations de plus de 7 jours',
    driverContact: 'Le chauffeur vous contactera 15 minutes avant l\'arrivée',
    haveIDReady: 'Ayez votre pièce d\'identité et permis de conduire prêts',
    support24_7_2: 'Assistance client 24/7 disponible',
    twoStepPayment: 'D\'abord, payez les frais de livraison (30฿). Après vérification et signature du contrat, vous paierez la location du véhicule séparément.',
    orderIdLabel: 'Numéro de commande :',
    dateLabel: 'Date :',
    paymentProcessTitle: 'Processus de paiement',
    paymentStep1: '1. Payer les frais de livraison (30฿) - Maintenant',
    paymentStep2: '2. Vérification des documents & signature du contrat',
    paymentStep3: '3. Payer la location du véhicule - Après contrat',
    paymentProcessNote: 'Cela garantit que votre réservation est confirmée et que le véhicule est réservé pour vous.',
    deliveryNotesOptional: 'Notes de livraison (Optionnel)',
    orderStatus: 'Statut de la commande',
    paymentPending: 'Paiement en attente',
    paymentComplete: 'Finaliser le paiement',
    
    // Новые для шагов оплаты
    stepDelivery: 'Étape 1 : Frais de livraison',
    stepVerification: 'Étape 2 : Vérification',
    stepRental: 'Étape 3 : Paiement location',
    currentStep: 'Étape actuelle :',
    nextStep: 'Étape suivante :',
    deliveryFeePaid: 'Frais de livraison payés',
    documentsVerified: 'Documents vérifiés',
    contractSigned: 'Contrat signé',
    bikePaymentReady: 'Paiement véhicule prêt',

    currencyNotice: 'Prix disponibles en THB, USD, EUR. Sélectionnez votre devise préférée ci-dessus.',
    displayPricesIn: 'Afficher les prix en:',
    
    // Bike Descriptions
    bikeDesc1: 'Scooter économique et fiable pour la ville',
    bikeDesc2: 'Scooter compact et maniable',
    bikeDesc3: 'Scooter urbain élégant et économique',
    bikeDesc4: 'Scooter puissant et confortable pour les longs trajets',
    bikeDesc5: 'Scooter moderne avec ABS et grand coffre',
    bikeDesc6: 'Scooter sportif au design vibrant',
    bikeDesc7: 'Scooter d\'aventure pour tout-terrain',
    bikeDesc8: 'Scooter de style italien classique',
    bikeDesc9: 'Maxi-scooter pour le tourisme confortable',
    bikeDesc10: 'Scooter de tourisme premium',
    bikeDesc11: 'Moto néo-classique moderne',
    bikeDesc12: 'Moto sportive pour la ville',
    bikeDesc13: 'Moto d\'aventure et tourisme',
    bikeDesc14: 'Sportive pour circuit et ville',
    bikeDesc15: 'Moto enduro tout-terrain',
    bikeDesc16: 'Moto urbaine premium',
    bikeDesc17: 'Moto d\'aventure pour longs voyages',
    bikeDesc18: 'Style et puissance italienne',
    bikeDesc19: 'Cruiser américain classique',
    bikeDesc20: 'Moto d\'aventure touring premium',
    
    // Currency Info
    currencyInfo1: 'Tous les prix sont convertis à la caisse',
    currencyInfo2: 'Pas de frais cachés ni de frais de conversion',
    currencyInfo3: 'Paiement traité dans la devise sélectionnée',
    currencyInfo4: 'Taux de change mis à jour quotidiennement',
    currencyInfoTitle: 'Informations sur la devise',
    
    // Location Delivery Times
    deliveryPhuket: 'Livraison: 60-90 minutes',
    deliveryBangkok: 'Livraison: 45-60 minutes',
    deliveryChiangmai: 'Livraison: 30-45 minutes',
    deliveryKrabi: 'Livraison: 60-90 minutes',
    deliveryPattaya: 'Livraison: 30-45 minutes',
    deliverySamui: 'Livraison: 60-90 minutes',
  },
  
  it: {
    // Navigation
    navBikes: 'Moto & Scooter',
    navBooking: 'Prenotazione',
    navLocations: 'Località',
    navContact: 'Contatti',
    
    // Hero Section
    heroTitle: 'Noleggio Moto e Scooter in Thailandia',
    heroSubtitle: 'Esplora la Thailandia con facilità! Nessun deposito passaporto • Consegna 24/7 • Supporto italiano',
    heroButton1: 'Sfoglia i veicoli',
    heroButton2: 'Prenota Ora',
    
    // Catalog
    catalogTitle: 'La nostra flotta di veicoli',
    filterAll: 'Tutti',
    filterScooters: 'Scooter',
    filterMotorcycles: 'Moto',
    popularBadge: 'Popolare',
    pricePerDay: '/giorno',
    bookButton: 'Prenota Ora',
    
    // Sorting
    sortBy: 'Ordina per',
    sortPriceLow: 'Prezzo: Crescente',
    sortPriceHigh: 'Prezzo: Decrescente',
    sortName: 'Nome A-Z',
    
    // Date Picker
    selectDates: 'Seleziona le date di noleggio *',
    datePlaceholder: 'Seleziona data di inizio e fine',
    
    // Booking Form
    bookingTitle: 'Modulo di Prenotazione',
    formName: 'Il tuo nome *',
    formEmail: 'Email *',
    formPhone: 'Telefono *',
    formBike: 'Seleziona veicolo',
    formDates: 'Date di noleggio *',
    formLocation: 'Luogo di ritiro *',
    formNotes: 'Richieste aggiuntive',
    formSubmit: 'Procedi al pagamento',
    formNotice1: '⚠️ Requisiti: Patente internazionale categoria A, passaporto, deposito cauzionale.',
    formNotice2: '📞 Dopo l\'invio, ti contatteremo per confermare la prenotazione.',
    
    // Price Preview
    priceSummary: 'Riepilogo Prezzi',
    selected: 'Selezionato',
    dailyRate: 'Tariffa giornaliera',
    days: 'Giorni',
    subtotal: 'Subtotale',
    
    // Locations
    locationsTitle: 'Le nostre sedi in Thailandia',
    locationService: 'Consegna 24/7 • Personale di lingua italiana',
    
    // Contact
    contactTitle: 'Contattaci',
    contactPhone: 'Telefono',
    contactEmail: 'Email',
    contactWhatsApp: 'WhatsApp / Telegram',
    contactHours: 'Orari di lavoro',
    contact24h: '24/7, 7 giorni su 7',
    
    // Footer
    footerTagline: 'Noleggio moto e scooter in tutta la Thailandia',
    footerAbout: 'Chi siamo',
    footerDescription: 'Servizio professionale di noleggio moto e scooter in tutta la Thailandia con supporto 24/7.',
    footerQuickLinks: 'Link rapidi',
    footerContactUs: 'Contattaci',
    footerAddress: 'Indirizzo: Soi Petchngam Tambon Talat Nuea, Amphoe Mueang Phuket, Chang Wat Phuket 83000, Thailandia',
    footerTerms: 'Termini e condizioni',
    footerPrivacy: 'Informativa sulla privacy',
    footerCancellation: 'Politica di cancellazione',
    footerLicense: 'Licenza aziendale: 0105556003095',
    footerVat: 'Partita IVA: TH0123456789013',
    footerRights: '© 2026 ThaiBike Rent. Tutti i diritti riservati.',
    footerSafety: 'Patente internazionale richiesta. Guida in sicurezza!',
    footerFollow: 'Seguici:',
    footerAllRights: 'Tutti i diritti riservati.',
    footerRequiredDocs: 'Documenti richiesti: Patente internazionale, passaporto, deposito cauzionale.',
    footerBusinessHours: 'Orari di apertura: 24/7',
    footerVerified: 'Verificato dal Ministero del turismo tailandese',
    footerInsurance: 'Assicurazione inclusa in tutti i noleggi',
    
    // Invoice Page
    invoiceTitle: 'Fattura di Prenotazione',
    orderNumber: 'Ordine #',
    rentalDetails: 'Dettagli Noleggio',
    customer: 'Cliente',
    email: 'Email',
    vehicle: 'Veicolo',
    rentalPeriod: 'Periodo di Noleggio',
    pickupLocation: 'Luogo di Ritiro',
    priceBreakdown: 'Dettaglio Prezzi',
    deliveryInformation: 'Informazioni Consegna',
    deliveryInfoText: 'Ora devi pagare la consegna del veicolo al tuo indirizzo. Inserisci il tuo indirizzo di consegna qui sotto.',
    deliveryCostFixed: 'Il costo di consegna è fisso a 30฿ in tutta la Thailandia.',
    deliveryTime: 'Tempo di consegna stimato: 60-90 minuti dopo la conferma.',
    streetAddress: 'Indirizzo *',
    city: 'Città *',
    postalCode: 'Codice Postale *',
    province: 'Provincia *',
    district: 'Distretto',
    country: 'Paese *',
    deliveryNotes: 'Note di consegna',
    enterValidAddress: 'Si prega di compilare tutti i campi dell\'indirizzo richiesti',
    deliveryConfirmed: 'Indirizzo di consegna salvato!',
    taxIncluded: 'Tutte le tasse incluse. Nessuna commissione nascosta.',
    securePayment: 'Pagamento sicuro SSL a 256 bit',
    backToBooking: '← Torna alla prenotazione',
    proceedToPayment: 'Procedi al pagamento sicuro',
    fillAllFields: 'Si prega di compilare tutti i campi obbligatori',
    calculateDeliveryFirst: 'Si prega di compilare prima l\'indirizzo di consegna',
    addressSaved: '✓ Indirizzo salvato',
    
    // Error Messages
    selectBikeDates: 'Seleziona un veicolo e le date',
    enterStreetCity: 'Inserisci indirizzo e città',
    deliveryFailed: 'Salvataggio indirizzo fallito. Riprova.',
    loading: 'Caricamento...',
    
    // Page Titles
    pageTerms: 'Termini e condizioni',
    pagePrivacy: 'Informativa sulla privacy',
    pageCancellation: 'Politica di cancellazione',
    
    // Terms Page Content
    termsTitle: 'Termini e condizioni di noleggio',
    termsEffective: 'Data di efficacia: 1 gennaio 2026',
    termsIntro: 'Benvenuto in ThaiBike Rent. Questi Termini e condizioni regolano il tuo noleggio di moto e scooter dal nostro servizio.',
    termsSection1: '1. Contratto di noleggio',
    termsContent1: 'Noleggiando un veicolo da ThaiBike Rent, accetti questi termini. Devi avere almeno 18 anni con una patente di guida internazionale valida.',
    termsSection2: '2. Periodo di noleggio',
    termsContent2: 'Il periodo di noleggio inizia al momento specificato nella tua prenotazione e termina quando il veicolo viene restituito. I ritardi comportano costi aggiuntivi.',
    termsSection3: '3. Condizione del veicolo',
    termsContent3: 'Riceverai il veicolo in buone condizioni di funzionamento. Sei responsabile per eventuali danni durante il periodo di noleggio.',
    termsSection4: '4. Assicurazione',
    termsContent4: 'L\'assicurazione di base è inclusa. La copertura aggiuntiva è disponibile per l\'acquisto.',
    termsSection5: '5. Pagamento',
    termsContent5: 'Il pagamento completo è richiesto prima del ritiro del veicolo. Accettiamo carte di credito e contanti.',
    termsContact: 'Per domande su questi termini, contattaci a info@thaibikerent.com.',
    
    // Privacy Page Content
    privacyTitle: 'Informativa sulla privacy',
    privacyEffective: 'Data di efficacia: 1 gennaio 2026',
    privacyIntro: 'ThaiBike Rent rispetta la tua privacy ed è impegnata a proteggere i tuoi dati personali.',
    privacySection1: '1. Informazioni che raccogliamo',
    privacyContent1: 'Raccogliamo informazioni personali come nome, email, numero di telefono, dettagli della patente di guida e informazioni di pagamento.',
    privacySection2: '2. Come utilizziamo le tue informazioni',
    privacyContent2: 'Le tue informazioni vengono utilizzate per elaborare i noleggi, fornire supporto clienti e migliorare i nostri servizi.',
    privacySection3: '3. Sicurezza dei dati',
    privacyContent3: 'Implementiamo misure di sicurezza per proteggere i tuoi dati personali da accessi non autorizzati.',
    privacySection4: '4. Condivisione dei dati',
    privacyContent4: 'Non vendiamo i tuoi dati. Possiamo condividere informazioni con le forze dell\'ordine se richiesto dalla legge.',
    privacySection5: '5. I tuoi diritti',
    privacyContent5: 'Hai il diritto di accedere, correggere o eliminare le tue informazioni personali.',
    
    // Cancellation Page Content
    cancellationTitle: 'Politica di cancellazione',
    cancellationEffective: 'Data di efficacia: 1 gennaio 2026',
    cancellationIntro: 'La nostra politica di cancellazione è progettata per essere equa sia per i clienti che per la nostra attività.',
    cancellationSection1: '1. Cancellazione gratuita',
    cancellationContent1: 'Cancella fino a 48 ore prima del ritiro per un rimborso completo.',
    cancellationSection2: '2. Cancellazione tardiva',
    cancellationContent2: 'Le cancellazioni entro 24-48 ore ricevono un rimborso del 50%.',
    cancellationSection3: '3. Mancata presentazione',
    cancellationContent3: 'Nessun rimborso per cancellazioni entro 24 ore o mancate presentazioni.',
    cancellationSection4: '4. Restituzione anticipata',
    cancellationContent4: 'Le restituzioni anticipate non danno diritto a rimborsi parziali.',
    cancellationSection5: '5. Cancellazioni meteorologiche',
    cancellationContent5: 'In caso di maltempo, offriamo una riprogrammazione o un rimborso completo.',
    
     // Invoice Page - Новые переводы
    customerInfo: 'Informazioni cliente',
    rentalDetails: 'Dettagli noleggio',
    deliveryInformation: 'Informazioni consegna',
    paymentSummary: 'Riepilogo pagamento',
    completeToProceed: 'Completa per procedere al pagamento',
    deliveryWithin60: 'Consegna in 60 minuti',
    deliveryFeeNote: 'Costo consegna standard: 30฿ • Disponibile 8:00-22:00',
    deliveryAddress: 'Indirizzo di consegna',
    requiredFields: '* Campi obbligatori',
    saveAddress: 'Salva indirizzo di consegna',
    saving: 'Salvataggio...',
    addressSavedSuccess: 'Indirizzo salvato con successo!',
    deliveryConfirmation: 'La consegna verrà effettuata a questo indirizzo entro 60 minuti.',
    fillRequiredFields: 'Si prega di compilare tutti i campi obbligatori contrassegnati con *',
    cardPaymentOnly: 'Solo pagamento con carta',
    deliveryFee: 'Costo consegna:',
    rentalAmount: 'Importo noleggio:',
    paidSeparately: 'Pagato separatamente',
    totalToPay: 'Totale da pagare:',
    creditDebitCard: 'Carta di credito/debito',
    cardTypes: 'Visa, MasterCard, American Express',
    payNow: 'Paga ora',
    secureNote: 'Il tuo pagamento è sicuro e crittografato. Non conserviamo i dati della carta.',
    needHelp: 'Hai bisogno di aiuto?',
    support24_7: 'Il nostro team di supporto è disponibile 24 ore su 24, 7 giorni su 7.',
    importantInfo: 'Informazioni importanti',
    freeDeliveryOver7: 'Consegna gratuita per noleggi oltre 7 giorni',
    driverContact: 'L\'autista ti contatterà 15 minuti prima dell\'arrivo',
    haveIDReady: 'Avere documento d\'identità e patente pronti',
    support24_7_2: 'Supporto clienti 24/7 disponibile',
    twoStepPayment: 'Prima, paga il costo di consegna (30฿). Dopo la verifica e la firma del contratto, pagherai il noleggio del veicolo separatamente.',
    orderIdLabel: 'ID ordine:',
    dateLabel: 'Data:',
    paymentProcessTitle: 'Processo di pagamento',
    paymentStep1: '1. Paga costo consegna (30฿) - Ora',
    paymentStep2: '2. Verifica documenti & firma contratto',
    paymentStep3: '3. Paga noleggio veicolo - Dopo contratto',
    paymentProcessNote: 'Ciò garantisce che la tua prenotazione sia confermata e il veicolo riservato per te.',
    deliveryNotesOptional: 'Note di consegna (Opzionale)',
    orderStatus: 'Stato ordine',
    paymentPending: 'Pagamento in sospeso',
    paymentComplete: 'Completa pagamento',
    
    // Новые для шагов оплаты
    stepDelivery: 'Passo 1: Costo consegna',
    stepVerification: 'Passo 2: Verifica',
    stepRental: 'Passo 3: Pagamento noleggio',
    currentStep: 'Passo corrente:',
    nextStep: 'Prossimo passo:',
    deliveryFeePaid: 'Costo consegna pagato',
    documentsVerified: 'Documenti verificati',
    contractSigned: 'Contratto firmato',
    bikePaymentReady: 'Pagamento veicolo pronto',

        // Currency
    currencyNotice: 'Prezzi disponibili in THB, USD, EUR. Seleziona la valuta preferita sopra.',
    displayPricesIn: 'Mostra prezzi in:',
    
    // Bike Descriptions
    bikeDesc1: 'Scooter economico e affidabile per la città',
    bikeDesc2: 'Scooter compatto e maneggevole',
    bikeDesc3: 'Scooter urbano elegante ed economico',
    bikeDesc4: 'Scooter potente e confortevole per viaggi lunghi',
    bikeDesc5: 'Scooter moderno con ABS e ampio bagagliaio',
    bikeDesc6: 'Scooter sportivo dal design vibrante',
    bikeDesc7: 'Scooter avventura per fuoristrada',
    bikeDesc8: 'Scooter in stile italiano classico',
    bikeDesc9: 'Maxi-scooter per tour confortevoli',
    bikeDesc10: 'Scooter da turismo premium',
    bikeDesc11: 'Moto neo-classica moderna',
    bikeDesc12: 'Moto sportiva per la città',
    bikeDesc13: 'Moto da avventura e turismo',
    bikeDesc14: 'Sportiva per pista e città',
    bikeDesc15: 'Moto enduro fuoristrada',
    bikeDesc16: 'Moto urbana premium',
    bikeDesc17: 'Moto da avventura per viaggi lunghi',
    bikeDesc18: 'Stile e potenza italiana',
    bikeDesc19: 'Cruiser americano classico',
    bikeDesc20: 'Moto da turismo avventura premium',
    
    // Currency Info
    currencyInfo1: 'Tutti i prezzi vengono convertiti alla cassa',
    currencyInfo2: 'Nessun costo nascosto o di conversione',
    currencyInfo3: 'Pagamento elaborato nella valuta selezionata',
    currencyInfo4: 'Tassi di cambio aggiornati quotidianamente',
    currencyInfoTitle: 'Informazioni sulla valuta',
    
    // Location Delivery Times
    deliveryPhuket: 'Consegna: 60-90 minuti',
    deliveryBangkok: 'Consegna: 45-60 minuti',
    deliveryChiangmai: 'Consegna: 30-45 minuti',
    deliveryKrabi: 'Consegna: 60-90 minuti',
    deliveryPattaya: 'Consegna: 30-45 minuti',
    deliverySamui: 'Consegna: 60-90 minuti',

  },
  
  es: {
    // Navigation
    navBikes: 'Motos & Scooters',
    navBooking: 'Reserva',
    navLocations: 'Ubicaciones',
    navContact: 'Contacto',
    
    // Hero Section
    heroTitle: 'Alquiler de Motos y Scooters en Tailandia',
    heroSubtitle: '¡Explora Tailandia con facilidad! Sin depósito de pasaporte • Entrega 24/7 • Soporte en español',
    heroButton1: 'Ver vehículos',
    heroButton2: 'Reservar Ahora',
    
    // Catalog
    catalogTitle: 'Nuestra flota de vehiculos',
    filterAll: 'Todos',
    filterScooters: 'Scooters',
    filterMotorcycles: 'Motos',
    popularBadge: 'Popular',
    pricePerDay: '/día',
    bookButton: 'Reservar Ahora',
    
    // Sorting
    sortBy: 'Ordenar por',
    sortPriceLow: 'Precio: Bajo a Alto',
    sortPriceHigh: 'Precio: Alto a Bajo',
    sortName: 'Nombre A-Z',
    
    // Date Picker
    selectDates: 'Seleccionar fechas de alquiler *',
    datePlaceholder: 'Seleccionar fecha de inicio y fin',
    
    // Booking Form
    bookingTitle: 'Formulario de Reserva',
    formName: 'Tu nombre *',
    formEmail: 'Email *',
    formPhone: 'Teléfono *',
    formBike: 'Seleccionar vehículo',
    formDates: 'Fechas de alquiler *',
    formLocation: 'Lugar de recogida *',
    formNotes: 'Solicitudes adicionales',
    formSubmit: 'Continuar al pago',
    formNotice1: '⚠️ Requisitos: Licencia internacional categoría A, pasaporte, depósito.',
    formNotice2: '📞 Después de enviar, te contactaremos para confirmar tu reserva.',
    
    // Price Preview
    priceSummary: 'Resumen de Precios',
    selected: 'Seleccionado',
    dailyRate: 'Tarifa diaria',
    days: 'Días',
    subtotal: 'Subtotal',
    
    // Locations
    locationsTitle: 'Nuestras ubicaciones en Tailandia',
    locationService: 'Entrega 24/7 • Personal de habla española',
    
    // Contact
    contactTitle: 'Contáctanos',
    contactPhone: 'Teléfono',
    contactEmail: 'Email',
    contactWhatsApp: 'WhatsApp / Telegram',
    contactHours: 'Horario de atención',
    contact24h: '24/7, 7 días a la semana',
    
    // Footer
    footerTagline: 'Alquiler de motos y scooters en toda Tailandia',
    footerAbout: 'Sobre nosotros',
    footerDescription: 'Servicio profesional de alquiler de motos y scooters en toda Tailandia con soporte 24/7.',
    footerQuickLinks: 'Enlaces rápidos',
    footerContactUs: 'Contáctanos',
    footerAddress: 'Dirección: 123 Beach Road, Patong, Phuket 83150, Tailandia',
    footerTerms: 'Términos y condiciones',
    footerPrivacy: 'Política de privacidad',
    footerCancellation: 'Política de cancelación',
    footerLicense: 'Licencia de empresa: 0105556003095',
    footerVat: 'NIF: TH0123456789013',
    footerRights: '© 2026 ThaiBike Rent. Todos los derechos reservados.',
    footerSafety: 'Se requiere licencia internacional. ¡Conduce con seguridad!',
    footerFollow: 'Síguenos:',
    footerAllRights: 'Todos los derechos reservados.',
    footerRequiredDocs: 'Documentos requeridos: Licencia internacional, pasaporto, depósito de seguridad.',
    footerBusinessHours: 'Horario comercial: 24/7',
    footerVerified: 'Verificado por el Ministerio de Turismo de Tailandia',
    footerInsurance: 'Seguro incluido en todos los alquileres',
    
    // Invoice Page
    invoiceTitle: 'Factura de Reserva',
    orderNumber: 'Pedido #',
    rentalDetails: 'Detalles del Alquiler',
    customer: 'Cliente',
    email: 'Email',
    vehicle: 'Vehículo',
    rentalPeriod: 'Periodo de Alquiler',
    pickupLocation: 'Lugar de Recogida',
    priceBreakdown: 'Desglose de Precios',
    deliveryInformation: 'Información de Entrega',
    deliveryInfoText: 'Ahora necesitas pagar la entrega de la moto a tu dirección. Ingresa tu dirección de entrega a continuación.',
    deliveryCostFixed: 'El costo de entrega es fijo a 30฿ en cualquier parte de Tailandia.',
    deliveryTime: 'Tiempo de entrega estimado: 60-90 minutos después de la confirmación.',
    streetAddress: 'Dirección *',
    city: 'Ciudad *',
    postalCode: 'Código Postal *',
    province: 'Provincia *',
    district: 'Distrito',
    country: 'País *',
    deliveryNotes: 'Notas de entrega',
    enterValidAddress: 'Por favor, complete todos los campos de dirección requeridos',
    deliveryConfirmed: '¡Dirección de entrega guardada!',
    taxIncluded: 'Todos los impuestos incluidos. Sin tarifas ocultas.',
    securePayment: 'Pago seguro SSL de 256 bits',
    backToBooking: '← Volver a la reserva',
    proceedToPayment: 'Proceder al pago seguro',
    fillAllFields: 'Por favor, complete todos los campos requeridos',
    calculateDeliveryFirst: 'Por favor, complete primero la dirección de entrega',
    addressSaved: '✓ Dirección guardada',
    
    // Error Messages
    selectBikeDates: 'Selecciona un vehículo y las fechas',
    enterStreetCity: 'Por favor ingresa la calle y ciudad',
    deliveryFailed: 'Error al guardar la dirección. Por favor intenta de nuevo.',
    loading: 'Cargando...',
    
    // Page Titles
    pageTerms: 'Términos y condiciones',
    pagePrivacy: 'Política de privacidad',
    pageCancellation: 'Política de cancelación',
    
    // Terms Page Content
    termsTitle: 'Términos y condiciones de alquiler',
    termsEffective: 'Fecha efectiva: 1 de enero de 2026',
    termsIntro: 'Bienvenido a ThaiBike Rent. Estos Términos y condiciones rigen su alquiler de motos y scooters de nuestro servicio.',
    termsSection1: '1. Contrato de alquiler',
    termsContent1: 'Al alquilar un vehículo de ThaiBike Rent, usted acepta estos términos. Debe tener al menos 18 años y tener una licencia de conducir internacional válida.',
    termsSection2: '2. Período de alquiler',
    termsContent2: 'El período de alquiler comienza en el momento especificado en su reserva y termina cuando se devuelve el vehículo. Las devoluciones tardías incurren en cargos adicionales.',
    termsSection3: '3. Condición del vehículo',
    termsContent3: 'Recibirá el vehículo en buenas condiciones de funcionamiento. Usted es responsable de cualquier daño durante su período de alquiler.',
    termsSection4: '4. Seguro',
    termsContent4: 'El seguro básico está incluido. La cobertura adicional está disponible para su compra.',
    termsSection5: '5. Pago',
    termsContent5: 'Se requiere el pago completo antes de la recogida del vehículo. Aceptamos tarjetas de crédito y efectivo.',
    termsContact: 'Para preguntas sobre estos términos, contáctenos en info@thaibikerent.com.',
    
    // Privacy Page Content
    privacyTitle: 'Política de privacidad',
    privacyEffective: 'Fecha efectiva: 1 de enero de 2026',
    privacyIntro: 'ThaiBike Rent respeta su privacidad y se compromete a proteger sus datos personales.',
    privacySection1: '1. Información que recopilamos',
    privacyContent1: 'Recopilamos información personal como nombre, correo electrónico, número de teléfono, detalles de la licencia de conducir e información de pago.',
    privacySection2: '2. Cómo usamos su información',
    privacyContent2: 'Su información se utiliza para procesar alquileres, brindar soporte al cliente y mejorar nuestros servicios.',
    privacySection3: '3. Seguridad de datos',
    privacyContent3: 'Implementamos medidas de seguridad para proteger sus datos personales del acceso no autorizado.',
    privacySection4: '4. Compartir datos',
    privacyContent4: 'No vendemos sus datos. Podemos compartir información con las fuerzas del orden si la ley lo requiere.',
    privacySection5: '5. Sus derechos',
    privacyContent5: 'Tiene derecho a acceder, corregir o eliminar su información personal.',
    
    // Cancellation Page Content
    cancellationTitle: 'Política de cancelación',
    cancellationEffective: 'Fecha efectiva: 1 de enero de 2026',
    cancellationIntro: 'Nuestra política de cancelación está diseñada para ser justa tanto para los clientes como para nuestro negocio.',
    cancellationSection1: '1. Cancelación gratuita',
    cancellationContent1: 'Cancela hasta 48 horas antes de la recogida para un reembolso completo.',
    cancellationSection2: '2. Cancelación tardía',
    cancellationContent2: 'Las cancelaciones dentro de 24-48 horas reciben un reembolso del 50%.',
    cancellationSection3: '3. No presentarse',
    cancellationContent3: 'Sin reembolso por cancelaciones dentro de las 24 horas o no presentarse.',
    cancellationSection4: '4. Devolución anticipada',
    cancellationContent4: 'Las devoluciones anticipadas no califican para reembolsos parciales.',
    cancellationSection5: '5. Cancelaciones por clima',
    cancellationContent5: 'En caso de mal tiempo, ofrecemos reprogramación o reembolso completo.',
    customerInfo: 'Información del cliente',
    rentalDetails: 'Detalles del alquiler',
    deliveryInformation: 'Información de entrega',
    paymentSummary: 'Resumen de pago',
    completeToProceed: 'Complete para proceder al pago',
    deliveryWithin60: 'Entrega en 60 minutos',
    deliveryFeeNote: 'Tarifa de entrega estándar: 30฿ • Disponible 8:00-22:00',
    deliveryAddress: 'Dirección de entrega',
    requiredFields: '* Campos obligatorios',
    saveAddress: 'Guardar dirección de entrega',
    saving: 'Guardando...',
    addressSavedSuccess: '¡Dirección guardada exitosamente!',
    deliveryConfirmation: 'La entrega se realizará a esta dirección dentro de 60 minutos.',
    fillRequiredFields: 'Por favor complete todos los campos obligatorios marcados con *',
    cardPaymentOnly: 'Solo pago con tarjeta',
    deliveryFee: 'Tarifa de entrega:',
    rentalAmount: 'Monto del alquiler:',
    paidSeparately: 'Pagado por separado',
    totalToPay: 'Total a pagar:',
    creditDebitCard: 'Tarjeta de crédito/débito',
    cardTypes: 'Visa, MasterCard, American Express',
    payNow: 'Pagar ahora',
    secureNote: 'Su pago es seguro y encriptado. No almacenamos datos de tarjetas.',
    needHelp: '¿Necesita ayuda?',
    support24_7: 'Nuestro equipo de soporte está disponible 24/7 para asistirle.',
    importantInfo: 'Información importante',
    freeDeliveryOver7: 'Entrega gratuita para alquileres de más de 7 días',
    driverContact: 'El conductor lo contactará 15 minutos antes de la llegada',
    haveIDReady: 'Tenga su identificación y licencia de conducir listas',
    support24_7_2: 'Soporte al cliente 24/7 disponible',
    twoStepPayment: 'Primero, pague la tarifa de entrega (30฿). Después de la verificación y firma del contrato, pagará el alquiler del vehículo por separado.',
    orderIdLabel: 'ID del pedido:',
    dateLabel: 'Fecha:',
    paymentProcessTitle: 'Proceso de pago',
    paymentStep1: '1. Pagar tarifa de entrega (30฿) - Ahora',
    paymentStep2: '2. Verificación de documentos & firma de contrato',
    paymentStep3: '3. Pagar alquiler del vehículo - Después del contrato',
    paymentProcessNote: 'Esto asegura que su reserva esté confirmada y el vehículo reservado para usted.',
    deliveryNotesOptional: 'Notas de entrega (Opcional)',
    orderStatus: 'Estado del pedido',
    paymentPending: 'Pago pendiente',
    paymentComplete: 'Completar pago',
    
    // Новые для шагов оплаты
    stepDelivery: 'Paso 1: Tarifa de entrega',
    stepVerification: 'Paso 2: Verificación',
    stepRental: 'Paso 3: Pago alquiler',
    currentStep: 'Paso actual:',
    nextStep: 'Próximo paso:',
    deliveryFeePaid: 'Tarifa de entrega pagada',
    documentsVerified: 'Documentos verificados',
    contractSigned: 'Contrato firmado',
    bikePaymentReady: 'Pago vehículo listo',

    // Currency
    currencyNotice: 'Precios disponibles en THB, USD, EUR. Seleccione su moneda preferida arriba.',
    displayPricesIn: 'Mostrar precios en:',
    
    // Bike Descriptions
    bikeDesc1: 'Scooter económico y confiable para la ciudad',
    bikeDesc2: 'Scooter compacto y maniobrable',
    bikeDesc3: 'Scooter urbano elegante y económico',
    bikeDesc4: 'Scooter potente y cómodo para viajes largos',
    bikeDesc5: 'Scooter moderno con ABS y gran almacenamiento',
    bikeDesc6: 'Scooter deportivo con diseño vibrante',
    bikeDesc7: 'Scooter de aventura para todoterreno',
    bikeDesc8: 'Scooter de estilo italiano clásico',
    bikeDesc9: 'Maxi-scooter para turismo cómodo',
    bikeDesc10: 'Scooter de turismo premium',
    bikeDesc11: 'Motocicleta neoclásica moderna',
    bikeDesc12: 'Motocicleta deportiva para ciudad',
    bikeDesc13: 'Motocicleta de aventura y turismo',
    bikeDesc14: 'Deportiva para pista y ciudad',
    bikeDesc15: 'Motocicleta enduro todoterreno',
    bikeDesc16: 'Motocicleta urbana premium',
    bikeDesc17: 'Motocicleta de aventura para viajes largos',
    bikeDesc18: 'Estilo y potencia italiana',
    bikeDesc19: 'Crucero americano clásico',
    bikeDesc20: 'Motocicleta de turismo aventura premium',
    
    // Currency Info
    currencyInfo1: 'Todos los precios se convierten en la caja',
    currencyInfo2: 'Sin tarifas ocultas ni cargos de conversión',
    currencyInfo3: 'Pago procesado en la moneda seleccionada',
    currencyInfo4: 'Tipos de cambio actualizados diariamente',
    currencyInfoTitle: 'Información de moneda',
    
    // Location Delivery Times
    deliveryPhuket: 'Entrega: 60-90 minutos',
    deliveryBangkok: 'Entrega: 45-60 minutos',
    deliveryChiangmai: 'Entrega: 30-45 minutos',
    deliveryKrabi: 'Entrega: 60-90 minutos',
    deliveryPattaya: 'Entrega: 30-45 minutos',
    deliverySamui: 'Entrega: 60-90 minutos',
  }
};

export const languageNames = {
  en: 'English',
  de: 'Deutsch',
  fr: 'Français',
  it: 'Italiano',
  es: 'Español'
};